import { render, staticRenderFns } from "./ContentVersionHistory.vue?vue&type=template&id=5bae8d18&scoped=true&"
import script from "./ContentVersionHistory.vue?vue&type=script&lang=js&"
export * from "./ContentVersionHistory.vue?vue&type=script&lang=js&"
import style0 from "./ContentVersionHistory.vue?vue&type=style&index=0&id=5bae8d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae8d18",
  null
  
)

export default component.exports